/*
 * @Author: wangliang wangliang@wiz.top
 * @Date: 2023-09-07 16:42:41
 * @LastEditors: fengxiaojing
 * @LastEditTime: 2024-03-12 14:26:13
 * @FilePath: \wiz-safety\src\modules\source-material-management\routes.js
 */
export default [
  {
    id: 'c135b9ac-0777-1b47-c384-22ce39e66534',
    name: 'source-material-management',
    path: '/source-material-management',
    meta: { title: '素材管理' },
    children: [
      {
        id: 'e6a90875-265f-1157-9dcc-72c5492650d8',
        path: 'model-base',
        name: 'model-base',
        component(resolve) {
          require(['./views/ModelBase'], resolve)
        },
        meta: {
          title: '模型管理',
          materialType: 1,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '详情',
              access: true,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '修改',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
            export: {
              id: 5,
              name: 'export',
              desc: '导出',
              access: true,
            },
            download: {
              id: 6,
              name: 'download',
              desc: '下载文件',
              access: true,
            },
            batchUpload: {
              id: 7,
              name: 'batchUpload',
              desc: '批量上传',
              access: true,
            },
          },
        },
      },
      {
        id: '652c76f0-9b39-286c-dff0-cdb9f4216f1a',
        path: 'kinetic-effect-management',
        name: 'kinetic-effect-management',
        component(resolve) {
          require(['./views/ModelBaseAction'], resolve)
        },
        meta: {
          title: '动效管理',
          materialType: 2,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '详情',
              access: true,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '修改',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
            export: {
              id: 5,
              name: 'export',
              desc: '导出',
              access: true,
              group: 'read',
            },
            download: {
              id: 6,
              name: 'download',
              desc: '下载文件',
              access: true,
              group: 'read',
            },
            batchUpload: {
              id: 7,
              name: 'batchUpload',
              desc: '批量上传',
              access: true,
            },
          },
        },
      },
      {
        id: '2fe59871-2e6b-a883-eebd-e739e4900501',
        path: 'engineering-management',
        name: 'engineering-management',
        component(resolve) {
          require(['./views/engineeringManagement'], resolve)
        },
        meta: {
          title: '工程模型管理',
          materialType: 3,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '详情',
              access: true,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '修改',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
    ],
  },
]
